import { render } from "./PieChartPlaceholder.vue?vue&type=template&id=2e65c062&scoped=true"
import script from "./PieChartPlaceholder.vue?vue&type=script&lang=js"
export * from "./PieChartPlaceholder.vue?vue&type=script&lang=js"

import "./PieChartPlaceholder.vue?vue&type=style&index=0&id=2e65c062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e65c062"]])

export default __exports__